// import axios from "axios"; 

// const LocationBasedService = {
//   // Fetch all purchase orders
//   async getAll(date) {
//     try {
//       const response = await axios.get(`/UserDetails/GetAttendenceDetails?p_date=${date}`, {
//       //  const response = await axios.get(`/LocationBasedCount/GetEmpLocationCount?p_date=${date}`, {
//         // headers: {
          
//         // },
//       });

//       console.log("API response:", response.data);
//       return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
//     } catch (error) {
//       console.error("Error fetching locations:", error);
//       throw error;
//     }
//   },
// }

// export default LocationBasedService;


import axios from "axios"; 

const LocationBasedService = {
  async getAll(date) {
    try {
      const response = await axios.get(
        `/UserDetails/GetAttendenceDetailsForDay?today=${date}`
      );

      console.log("API response:", response.data);
      
      if (response.data && Array.isArray(response.data.resultSet)) {
        // Transform the API response to match your component's expected format
        return response.data.resultSet.map(item => ({
          Emp_location: item.location,
          Emp_Total: item.TotalEmp,
          Emp_real: item.TodayAtt,
          Percentage: item.Percentage,
          // Keep original data as well if needed
          location: item.location,
          TotalEmp: item.TotalEmp,
          TodayAtt: item.TodayAtt,
        }));
      } else {
        console.warn("Unexpected API response structure:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching location data:", error);
      throw error;
    }
  },
}

export default LocationBasedService;